import {CreateDatingProfileView} from "./createDatingProfileView";
import {IPresenter} from "@/rawdogjs/src/interfaces/IPresenter";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";
import {Router} from "@/rawdogjs/src/router";
import {UserStore} from "../../../data/stores/UserStore";
import {ErrorBase} from "@/rawdogjs/src/core/ErrorBase";
import {RenderComponent} from "@/rawdogjs/src/renderRoute";
import {RadioTagsPresenter} from "../../common/radioTags/radioTagsPresenter";
import {DatingProfileApi} from "../../../services/api/base/DatingProfileApi";

export class CreateDatingProfilePresenter implements IPresenter {

    public _view: CreateDatingProfileView;
    private dependencyContainer: ParcelDependencyContainer;
    private _router: Router;
    private _userStore: UserStore;

    private errors: ErrorBase[] = [];
    private serverErrors: ErrorBase[] = [];

    constructor(view: CreateDatingProfileView, router: Router, dependencyContainer: ParcelDependencyContainer) {
        this._view = view;
        this.dependencyContainer = dependencyContainer;
        this._router = router;
    }

    async initialize() {

        this._view.bind(
            this,
            async (fieldSelector, value, fieldName) => {
                await this.handleFormChange(fieldSelector, value, fieldName);
            }
        );

        const renderComponent = new RenderComponent(this._router);

        const whatAreYouLookingForComponent =
            await renderComponent.render<RadioTagsPresenter>('common/radioTags');

        whatAreYouLookingForComponent.dataBind(
            {
                items: [
                    {name: 'Long-term partner', value: 1},
                    {name: 'Long-term, open to short', value: 2},
                    {name: 'Short term, open to long', value: 3}
                ]
            },
            'what-are-you-looking-for'
        );

        this._view.attachComponent(whatAreYouLookingForComponent, '#what-are-you-looking-for');

        this._view.scrollToTop();
    }

    async handleFormChange(fieldSelector: string, value: string, fieldName: string) {
        // validate and then set the field errors
        await this.validate();
        this._view.setFieldErrors(this.errors, fieldName);
    }
    
    async validate() {

    }

    async save() {

        const api = this.dependencyContainer.resolve<DatingProfileApi>('DatingProfileApi');

        const result = await api.post(
            {
                setAge: {age: this._view.age}
            },
            this._userStore.getParentTenant(),
            true
        )

        if (result.data?.errors) {
            this.serverErrors.push(result.data.errors);
        }

        return;

    }


    // getCombinedErrors() {
    //     return this.errors.concat(this.serverErrors);
    // }


    inject() {
    }

}

